/** Standard page-size choices for paginated tables across the application. */
export const DEFAULT_TABLE_PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const;
